export const NOTIFICATION_ACTIONS = {
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAILED: "GET_NOTIFICATIONS_FAILED",
  CLEAR_NOTIFICATION_STORE: "CLEAR_NOTIFICATION_STORE",
};
